export const MNEMONIC= "pig kingdom thrive upper thing swallow cattle chief bleak cancel hood kitchen"